import copy from "copy-to-clipboard";

export function copyToClipboard(text, options = { format: "text/plain" }) {
  return new Promise((resolve, reject) => {
    if (copy(text, options)) {
      resolve();
    } else {
      reject();
    }
  });
}
